// extracted by mini-css-extract-plugin
export default {"ganttVerticalContainer":"gantt_ganttVerticalContainer__s8bUN","horizontalContainer":"gantt_horizontalContainer__pW482","wrapper":"gantt_wrapper__paa4x"};